import { useCarromm } from '../../context/carrom';
import ImageDataTable from './ImageDataTable/imageDataTable';
import JSZip from 'jszip';
import axios from 'axios';
import { FaDownload } from 'react-icons/fa6';
import { toast } from 'react-hot-toast';
import { Tooltip } from 'react-tooltip';
function DataTable() {
  const carrom = useCarromm();
  const footerData = carrom?.holdFile
  const countNotNullValues = footerData.filter(item => item?.value !== null)?.length;
  const countStatusProceed = footerData.filter(item => item?.uploadStatus === 'processed')?.length;
  const countStatusFailed = footerData.filter(item => item?.uploadStatus === 'processing_failed')?.length;
  const allUrls = footerData.map(item => item?.output_url).filter(url => url);
  const countOutputUrlsWithValue = footerData.filter(item => item?.output_url !== null && item?.output_url?.length > 0)?.length;
  const handleDownload = async (outputUrls) => {
    const zip = new JSZip();

    const downloadPromises = outputUrls.map(async (output_url) => {
      const fileName = output_url.split('/').pop();
      if (!fileName) {
        toast('Download file not found');
        return;
      }
      try {
        const response = await axios.get(output_url, { responseType: 'blob' });
        zip.file(fileName, response.data);
      } catch (error) {
        console.error('Error downloading file:', error.message);
      }
    });

    // Wait for all download promises to resolve
    await Promise.all(downloadPromises);

    // Generate the zip file
    zip.generateAsync({ type: 'blob' })
      .then(function (content) {
        // Trigger the download of the zip file
        const url = window.URL.createObjectURL(content);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'images.zip';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(function (error) {
        console.error('Error generating zip file:', error);
      });
  }
  return (
    <div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50  d">
            <tr>
              <th scope="col" className="px-6 py-3">
                S.Nr.
              </th>
              <th scope="col" className="px-6 py-3">
                Bild
              </th>

              <th scope="col" className="px-6 py-3">
                Url
              </th>
              <th scope="col" className="px-6 py-3">
                Status
              </th>
              <th scope="col" className="px-6 py-3">
                Sku id
              </th>
              <th scope="col" className="px-6 py-3">
                Endgültiges Bild
              </th>
              <th scope="col" className="px-6 py-3">
                Aktion
              </th>
            </tr>
          </thead>
          <tbody>
            <ImageDataTable
              fileDetails={carrom?.holdFile} />
          </tbody>
          <tfoot>
            <tr className="font-semibold text-gray-900">
              <td className="px-6 py-3">{footerData?.length}</td>
              <td className="px-6 py-3"></td>
              <td className="px-6 py-3">{countNotNullValues || 0}</td>
              <td className="px-6 py-3">
                <div className='flex cursor-pointer'>
                  <Tooltip
                    id={`viewtop`}
                    place={"top"}
                  />
                  <div
                    // eslint-disable-next-line
                    data-tooltip-id={`viewtop`}
                    data-tooltip-content={`Anzahl der verarbeiteten Dateien`}>
                    <span className='text-green-700'>{countStatusProceed || 0}</span>
                  </div>/
                  <Tooltip
                    id={`viewtop2`}
                    place={"top"} />
                  <div
                    // eslint-disable-next-line
                    data-tooltip-id={`viewtop2`}
                    data-tooltip-content={`Anzahl der Dateien, die nicht verarbeitet werden konnten.`}>
                    <span className='text-red-700'>{countStatusFailed || 0}</span>
                  </div>
                </div>
              </td>
              <td className="px-6 py-3"></td>
              <td className="px-6 py-3">{countOutputUrlsWithValue || 0}</td>
              <td className="px-6 py-3">
                {allUrls?.length > 0 && (footerData[carrom?.holdFile?.length - 1]?.uploadStatus === "processing_failed" || footerData[carrom?.holdFile?.length - 1]?.uploadStatus === "processed") && <button className="btn-primary flex gap-3" onClick={() => { handleDownload(allUrls) }}  ><FaDownload /><span>Alle Dateien herunterladen</span></button>}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
  )
}

export default DataTable